// extracted by mini-css-extract-plugin
export default {"container":"CouponModal_container__VvS+f"};